module.exports = __webpack_public_path__ + "static/media/jasper-20.a6b73a99.jpg";